<template>
  <SectionSplit
    class="Meeting2026LinkReconvened reverse"
    src="../../assets/landing-finances/meeting-2026-link-reconvented.jpg">
    <h3>
      {{ $t("title") }}
    </h3>
    <p
      v-for="(paragraph, index) in $t('paragraphs')"
      :key="index"
      v-html="paragraph" />
  </SectionSplit>
</template>

<script>
import SectionSplit from 'views/components/SectionSplit'

export default {
  components: { SectionSplit },
}
</script>

<style lang="scss">
.Meeting2026LinkReconvened {
  .Splitter-body {
    max-width: 50rem;
  }

  .body {
    padding: 2rem 0;
  }
}
</style>

<i18n>
{
  "en": {
    "title": "Convocation of Reconvened Bondholders’ Meeting of Sun Investment Group, UAB on May 28, 2026",
    "paragraphs": [
      "Sun Investment Group, UAB hereby informs that the reconvened bondholders’ meeting will be convened on 28 May 2026, 10 a.m.<br><br>Meeting will take place online, via Zoom platform (<a href=\"https://zoom.us/join\" target=\"_blank\">https://zoom.us/join</a>), using the following credentials for joining:<br>Meeting <b>ID: 827 0644 4217</b><br><b>Passcode: UpU40D</b><br><br>Details regarding the meeting agenda, procedures, and participation instructions can be found in the official notice published on the Nasdaq website.<br><br>Nasdaq link: <a href=\"https://view.news.eu.nasdaq.com/view?id=1443273&lang=en\" target=\"_blank\">Convocation of Reconvened Bondholders&#39; Meeting of Sun Investment Group, UAB on May 28, 2026</a>"    ]
  },
  "lt": {
    "title": "Sun Investment Group, UAB obligacijų savininkų pakartotinio susirinkimo sušaukimas 2026 m. gegužės 28 d.",
    "paragraphs": [
      "Informuojame, kad 2026 m. gegužės 28 d., 10:00 val. yra šaukiamas Sun Investment Group, UAB obligacijų savininkų pakartotinis susirinkimas.<br><br>Susirinkimas vyks nuotoliniu būdu, per Zoom platformą (<a href=\"https://zoom.us/join\" target=\"_blank\">https://zoom.us/join</a>), naudojantis šiais prisijungimo duomenimis:<br>Susirinkimo <b>ID: 827 0644 4217</b><br><b>Slaptažodis: UpU40D</b><br><br>Išsami informacija apie pakartotinio susirinkimo darbotvarkę, tvarką ir dalyvavimo instrukcijas pateikiama oficialiame pranešime, paskelbtame „Nasdaq“ svetainėje.<br><br>Nasdaq nuoroda: <a href=\"https://view.news.eu.nasdaq.com/view?id=1443273&lang=lt\" target=\"_blank\">Sun Investment Group, UAB obligacijų savininkų pakartotinio susirinkimo sušaukimas 2026 m. gegužės 28 d.</a>"
    ]
  }
}
</i18n>
